import TypeSelector from './typeSelector'

export default TypeSelector